export const environment = {
  configurator: 'd4dfce61-4f55-47f7-8164-a8822577aa7e',
  klaraApiUrl: 'https://test.api.klarsolar.de',
  environment: 'test',
  production: true,
  configCatSdkToken: 'fS7aCOBHoUmHsqcnPuGpnw/ucizzkjBgkSRxK9mrSwHng',
};
